var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfilSeleccionIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.019,
    height: 80.225,
    viewBox: "0 0 119.019 80.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_509",
    "data-name": "Grupo 509",
    transform: "translate(-403.665 -540.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_500",
    "data-name": "Grupo 500",
    transform: "translate(-475.27 47.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person-add",
    transform: "translate(917.728 492.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_214",
    "data-name": "Trazado 214",
    d: "M957.841,532.643a20.056,20.056,0,1,0-20.056-20.056A20.116,20.116,0,0,0,957.841,532.643Zm0,10.028c-13.538,0-40.113,6.518-40.113,20.056v10.028h80.225V562.727C997.953,549.189,971.379,542.671,957.841,542.671Z",
    transform: "translate(-917.728 -492.53)",
    fill: "#409cce"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_508",
    "data-name": "Grupo 508",
    transform: "translate(311.679 309.63)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_562",
    "data-name": "Rect\\xE1ngulo 562",
    width: 43,
    height: 7,
    transform: "translate(92.321 237.37)",
    fill: "#409cce"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_563",
    "data-name": "Rect\\xE1ngulo 563",
    width: 43.335,
    height: 6.99,
    transform: "translate(91.986 252.471)",
    fill: "#409cce"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_564",
    "data-name": "Rect\\xE1ngulo 564",
    width: 43.335,
    height: 6.99,
    transform: "translate(91.986 266.917)",
    fill: "#409cce"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfilSeleccionIcon01);
export default __webpack_public_path__ + "static/media/perfil-seleccion-icon-01.d3c41889f40984a646bf1960863dad18.svg";
export { ForwardRef as ReactComponent };